import React from 'react';
import { Col, Container, Row } from 'reactstrap';
import { Link } from 'react-router-dom';

import { frontendBuildInfo, isUnknown } from '../utils/buildInfo';

const Footer = () => {
  const { version } = frontendBuildInfo;
  const versionLabel = isUnknown(version) ? 'dev build' : version;

  return (
    <React.Fragment>
      <footer className='footer galaxy-border-none'>
        <Container fluid>
          <Row>
            <Col sm={6}>{new Date().getFullYear()} © Pertamina Patra Niaga</Col>
            <Col sm={6}>
              <div className='text-sm-end d-none d-sm-block'>
                Digital Procurement Hydro Application{' '}
                <Link
                  to='/version'
                  title='Lihat informasi versi & update terakhir'
                >
                  {versionLabel}
                </Link>
              </div>
            </Col>
          </Row>
        </Container>
      </footer>
    </React.Fragment>
  );
};

export default Footer;
